export default __webpack_public_path__ + "static/media/ec1.b4b789ad.png";